import {Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'atr-hero-card-swiper',
  templateUrl: './hero-card-swiper.component.html',
  styleUrls: ['./hero-card-swiper.component.scss']
})
export class HeroCardSwiperComponent  {
  @Input() screenMode;
  @ViewChild('tile', { static: true}) tile!: ElementRef<HTMLElement>;
  @ViewChild('imageRef', { static: true}) imageRef!: ElementRef<HTMLElement>;
  @ViewChild('titleRef', { static: true}) titleRef!: ElementRef<HTMLElement>;
  @ViewChild('descriptionRef', { static: true}) descriptionRef!: ElementRef<HTMLElement>;
  @ViewChild('channelRef', { static: true}) channelRef!: ElementRef<HTMLElement>;


  get hasImage() {
    return this.imageRef.nativeElement.childNodes.length > 0;
  }
  get hasTitle() {
    return this.titleRef.nativeElement.childNodes.length > 0;
  }
  get hasDescription() {
    return this.descriptionRef.nativeElement.childNodes.length > 0;
  }
  get hasChannel() {
    return this.channelRef.nativeElement.childNodes.length > 0;
  }

  constructor() { }

}
